import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon } from '@paypalcorp/pp-react';
import TemplateData, { localsMessages } from '../utility/getTemplateData';
import { StyleSheet, css } from 'aphrodite';
import _get from 'lodash/get';
import * as FPT from '../utility/fpt';

let messages = localsMessages('common/offerdetail');

const styles = StyleSheet.create({
  saveButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 'auto',
    maxWidth: 415,
    '@media (max-width: 576px)': {
      justifyContent: 'center',
    },
  },
});

class OfferSaveButton extends React.Component {
  printPage = () => {
    window.print();
    FPT.trackLinkClick('voucherprint');
  };

  sharePage = ({ title, text }) => {
    navigator.share({
      title,
      text,
    });
    FPT.trackLinkClick('vouchershare');
  };

  handleClick = (event) => {
    event.preventDefault();
    if (TemplateData.isdesktop || !navigator.share) {
      this.printPage();
    } else {
      const { offerProgram, txnStatement } = this.props;
      this.sharePage({
        title: _get(offerProgram, 'subTitle'),
        text: `${txnStatement} ${_get(offerProgram, 'description')}`,
      });
    }
  };

  render() {
    return (
      <div className="ppvx-row">
        <div className={css(styles.saveButton)}>
          <Link
            href="#"
            onClick={this.handleClick}
            style={{ fontSize: '14px' }}
          >
            <Icon name="download" size="sm" /> {messages.offer.button.text}
          </Link>
        </div>
      </div>
    );
  }
}

OfferSaveButton.propTypes = {
  offerProgram: PropTypes.object.isRequired,
  txnStatement: PropTypes.string,
};

export default OfferSaveButton;
